import { INVESTMENT_COUNTRY_CODES } from '@inversor-hub/types';

const spanishRegionNames = new Intl.DisplayNames(['es'], { type: 'region' });

export const investmentCountryOptions = INVESTMENT_COUNTRY_CODES.map((code) => ({
  code,
  label: spanishRegionNames.of(code) ?? code,
})).sort((a, b) => a.label.localeCompare(b.label, 'es'));

export const getInvestmentCountryLabel = (country?: string) =>
  investmentCountryOptions.find((option) => option.code === country)?.label ?? country ?? 'España';
